import type { MarketingHubSlug } from '@/lib/routing/navTree';
import { normalizeIllustrationPath } from './illustrationUtils';
import { CategoryHeroIllustration } from './categoryIllustrations';
import { HubHeroIllustration } from './hubIllustrations';
import { LeafHeroIllustration } from './leafIllustrations';

const SPECIAL_ROOTS = new Set([
  'about',
  'blog',
  'careers',
  'company',
  'consultation',
  'contact',
  'help',
  'pricing',
  'privacy',
  'resources',
]);

export type MarketingIllustrationProps = {
  path: string;
  className?: string;
};

/**
 * Resolves hub (depth 1), category (depth 2), leaf (depth 3+), and special routes
 * to theme-aware SVG hero illustrations.
 */
export function MarketingPathIllustration({ path, className }: MarketingIllustrationProps) {
  const normalized = normalizeIllustrationPath(path);
  const segments = normalized.split('/').filter(Boolean);

  if (segments.length === 0) {
    return <HubHeroIllustration hub="services" className={className} />;
  }

  if (segments.length === 1) {
    const hub = segments[0] as MarketingHubSlug;
    if (SPECIAL_ROOTS.has(segments[0])) {
      return <LeafHeroIllustration path={normalized} className={className} />;
    }
    return <HubHeroIllustration hub={hub} className={className} />;
  }

  if (segments.length === 2) {
    return <CategoryHeroIllustration path={normalized} className={className} />;
  }

  return <LeafHeroIllustration path={normalized} className={className} />;
}
